import { createLogic } from 'redux-logic';
import { AuthMethod, LEGACY_WIDGET_AUTH_METHOD } from 'config/constants';
import { getGatekeeperTokenForBooking } from 'lib/gatekeeperApi';
import { getBookingAuthMethod } from 'lib/graphql';
import * as authenticationActions from '../actions';
import * as sbaActions from '../sba/actions';

const getAuthMethod = ({ data }) => {
  if (data.authMethod === LEGACY_WIDGET_AUTH_METHOD) {
    return AuthMethod.WIDGET;
  }

  return data.authMethod;
};

const retrieveBookingAuthenticationMethod = createLogic({
  type: authenticationActions.retrieveBookingAuthMethod,
  async process({ action, client }, dispatch, done) {
    const { bookingId, split } = action.payload;

    const result = await getBookingAuthMethod(client, {
      variables: { bookingId },
      fetchPolicy: 'cache-first',
    });
    const authMethod = getAuthMethod(result);

    dispatch(authenticationActions.updateAuthMethod({ authMethod }));

    if (authMethod === AuthMethod.SBA) {
      const token = getGatekeeperTokenForBooking(bookingId);
      dispatch(sbaActions.updateSBAAuthentication({ token }));
      dispatch(authenticationActions.updateFetchBookingAuthProcess({ done: true }));
    }

    if (split && authMethod === AuthMethod.WIDGET) {
      dispatch(authenticationActions.updateFetchBookingAuthProcess({ done: true }));
    }

    done();
  },
});

export default retrieveBookingAuthenticationMethod;
